<template>
  <footer class="site-footer">
    <p>NMB48劇場 公演情報 - 非公式サイト</p>
    <nav>
      <router-link to="/">公演情報</router-link>
      <router-link to="/advertising">広告について</router-link>
      <router-link to="/privacy-policy">プライバシーポリシー</router-link>
    </nav>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
};
</script>

<style scoped>
.site-footer {
  max-width: 800px;
  margin: 32px auto 24px;
  padding: 16px 12px 0;
  border-top: 1px solid #ddd;
  color: #666;
  font-size: 13px;
  text-align: center;
}

.site-footer p {
  margin: 0 0 8px;
}

.site-footer nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.site-footer a {
  color: #336699;
  text-decoration: none;
}

.site-footer a:hover {
  text-decoration: underline;
}
</style>
